module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-regular.bb50c07.ttf";